import { render, staticRenderFns } from "./ScienceBlurb.vue?vue&type=template&id=90a28d88&scoped=true&"
import script from "./ScienceBlurb.vue?vue&type=script&lang=js&"
export * from "./ScienceBlurb.vue?vue&type=script&lang=js&"
import style0 from "./ScienceBlurb.vue?vue&type=style&index=0&id=90a28d88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a28d88",
  null
  
)

export default component.exports